<template>
<div class="container container-table">
	<div class="row vertical-10p">
		<div class="container text-center">
			<img src="/network/static/img/logo.jpg" class="center-block logo">
			<h3>Страницата не е намерена</h3>
			<router-link class="btn btn-primary" to="/">към Начална страница</router-link>
		</div>
	</div>
</div>
</template>
<script>
	module.exports = {
		name: 'NotFound'
	};
</script>
<style>


</style>



// WEBPACK FOOTER //
// 404.vue?6b4b4b18